<template>
  <v-card class="clubbing-card">
    <h2>Trip Un-Clubbing</h2>
    <div class="clubbing-list">
      <div class="clubbing-header">
        <span class="check-block"></span>
        <span>Details</span>
        <span>SI Comment</span>
        <span class="content-block">{{ tripDetails.serviceType === 1 ? "Pickup" : "Drop" }} Address</span>
        <span>Drop Off Time</span>
        <span>Reporting Time</span>
      </div>
      <div class="clubbed-trips">
        <div class="clubbed-trips-list" v-for="(employee, index) in tripDetails.employees" :key="index">
          <span class="check-block"><v-checkbox dense hide-details v-model="employee.selectedStatus"></v-checkbox></span>
          <span
            >{{ employee.name }}<br /><span class="extra-info">Crew ID:{{ employee.crewId }}</span></span
          >
          <span>{{ employee.siComment ? employee.siComment : "- - -" }}</span>
          <span class="content-block">{{ employee.address }}</span>
          <span v-if="tripDetails.serviceType === 1">{{ formatDateAndTime(employee.reportingTime, "date", "drop") }}<br />{{ formatDateAndTime(employee.reportingTime, "time", "drop") }}</span>
          <span v-else>---</span>
          <span>{{ formatDateAndTime(employee.reportingTime, "date", "rep") }}<br />{{ formatDateAndTime(employee.reportingTime, "time", "rep") }}</span>
        </div>
      </div>

      <div class="button-block">
        <v-btn :disabled="!isAnyEmployeeSelected" color="#147a19" @click="checkUnclubTrip">UnClub</v-btn>
        <v-btn color="#6d1711" @click="closeDialog">Cancel</v-btn>
      </div>
    </div>

    <Confirm ref="confirm"></Confirm>

    <loading v-if="loading"></loading>
  </v-card>
</template>

<script>
import moment from "moment";
import Confirm from "@/components/common/Confirm";
import loading from "@/components/common/Loading";
import axios from "@/axios/axios-global";
export default {
  name: "TripUnClubbing",
  components: { Confirm, loading },
  props: {
    tripDetails: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.tripDetails.employees.map((trip) => {
      this.$set(trip, "selectedStatus", false);
    });
  },
  computed: {
    isAnyEmployeeSelected() {
      return this.tripDetails.employees.some((employee) => employee.selectedStatus);
    },
  },

  methods: {
    formatDateAndTime(date, type, timeType) {
      if (type === "date") {
        return timeType === "drop" ? moment(date).subtract(20, "minutes").format("DD-MM-YYYY") : moment(date).format("DD-MM-YYYY");
      } else {
        return timeType === "drop" ? moment(date).subtract(20, "minutes").format("HH:mm ") : moment(date).format("HH:mm ");
      }
    },
    checkUnclubTrip() {
      if (this.tripDetails.employees.every((trip) => trip.selectedStatus === true)) {
        this.$toasted.show("Cannot unassign every crew", {
          position: "bottom-center",
          duration: 4000,
        });
      } else {
        const crewIds = this.tripDetails.employees.filter((employee) => employee.selectedStatus).map((employee) => employee.crewId);
        if (this.tripDetails.employees.length > 1) {
          this.unclubTrip(crewIds);
        } else {
          this.$emit("check-unassign", crewIds);
        }
      }
    },
    async unclubTrip(crewIds) {
      try {
        this.loading = true;
        let confirmTitle = "Confirm Un-Assign";
        let confirmText = "Please confirm to Un-Assign this Driver";
        if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
          const payload = {
            tripid: this.tripDetails.bigId,
            crewId: crewIds,
          };
          console.log(payload,"Trip/unclub")
          const response = await axios.post("trip/unclub", payload);
          console.log(response);
          if (response.status === 200) {
            this.loading = false;
            this.$emit("submit-unclub");
            this.$toasted.show(response.data.message, {
              position: "bottom-center",
              duration: 4000,
            });
          } else {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          }
        }
      } catch (error) {
        this.loading = false;
        this.$toasted.show(response.data, {
          position: "bottom-center",
          duration: 4000,
        });
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.tripDetails.employees.map((trip) => {
        this.$set(trip, "selectedStatus", false);
      });
      this.$emit("close-dialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.clubbing-card {
  padding: 15px;
  border-radius: 0;
  h2 {
    text-align: center;
    border-bottom: 1px solid #d5d5d5;
    font-weight: bold;
  }
  .clubbing-list {
    padding: 10px;
    width: 100%;
    .clubbing-header span {
      color: #6a0737 !important;
      font-weight: 600 !important;
    }
    .clubbing-header,
    .clubbed-trips-list {
      display: flex;
      padding: 8px;
      border: 1px solid #e3e3e3;
      align-items: center;
      gap: 10px;
      border-bottom: none;
      span,
      li {
        width: 15%;
        font-size: 12px;
        color: black;
        font-weight: bolder;
        text-align: center;
      }
      .check-block {
        width: 3%;
      }
      .extra-info {
        color: #096181c3;
      }
      .content-block {
        flex: 1;
      }

      &:last-child {
        border: 1px solid #e3e3e3;
      }

      ::v-deep .v-label {
        font-size: 12px;
        color: #6a0737 !important;
        font-weight: 600 !important;
      }
      .v-input--selection-controls {
        margin-top: 0;
        padding-top: 0;
      }
    }
    .sub-list {
      display: flex;
      flex-direction: column;
      width: 12%;
      li {
        width: 100%;
        list-style-type: disc;
      }
    }
  }

  .button-block {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 20px 0;

    .v-btn {
      color: #ffffff;
      font-weight: bold;
    }
  }
  //  .clubbed-trips {

  //  }
}
</style>
